function differenceDate(dateA: Date, dateB: Date): number{
    return dateA.getTime() - dateB.getTime();
}

export {differenceDate};
